import { render, staticRenderFns } from "./ModalText.vue?vue&type=template&id=9457ac66&scoped=true&"
import script from "./ModalText.vue?vue&type=script&lang=js&"
export * from "./ModalText.vue?vue&type=script&lang=js&"
import style0 from "./ModalText.vue?vue&type=style&index=0&id=9457ac66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9457ac66",
  null
  
)

export default component.exports